// @ts-nocheck
import React from 'react';
import { navigate } from '../../../../lib/routerAdapter';
import { pddTestApi } from '../../../../lib/api';
import CommonListPage from '../../../../components/hoc/common/handbook/ListPage';
import Page from '../../../../components/hoc/common/handbook/PageContext';
import { getBreadCrumbsByUrl } from '../../../../lib/autoBreadcrumbs';
import { pddTestEnum } from '../../../../lib/enum';
import { Filter } from './components';
import { withUserAccess } from '../../../withUserAccess';
const entryPointPath = '/admin/pdd/test/register/';
const columns = [{
  title: 'Наименование теста',
  dataIndex: 'name',
  width: 300,
  render: name => <div style={{
    whiteSpace: 'break-spaces'
  }}>{name}</div>
}, {
  title: 'Тип',
  dataIndex: 'type',
  render: type => pddTestEnum[type]
}, {
  title: 'Тема ПДД',
  dataIndex: 'pddTestGroups',
  width: 400,
  render: pddTestGroups => <div style={{
    whiteSpace: 'break-spaces'
  }}>
        {pddTestGroups?.map(el => el.pddGroup.name).join(', ')}
      </div>
}, {
  title: 'Тест по билетам',
  dataIndex: 'withoutTickets',
  render: withoutTickets => !withoutTickets ? 'Да' : 'Нет'
}, {
  title: 'Кол-во вопросов в тесте',
  dataIndex: 'questionsCount'
}];
const breadCrumbs = getBreadCrumbsByUrl(entryPointPath);
const access = {
  add: () => navigate(`${entryPointPath}new`)
};
export default withUserAccess(props => {
  return <Page>
      <CommonListPage crud={pddTestApi} pageHeaderProps={{
      breadCrumbs,
      mainHeader: 'Тестирование ПДД',
      access
    }} tableListProps={{
      columns,
      onSelect: id => navigate(`${entryPointPath}edit/${id}`),
      canDelete: true
    }} filter={Filter} />
    </Page>;
});
